"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Permissions_values, _Permissions_ende, _ClaimsBuilder_openID, _ClaimsBuilder_cognito, _ClaimsBuilder_boum, _ClaimsBuilder_employee, _ClaimsBuilder_customer, _ClaimsBuilder_internal;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsBuilder = exports.WithDefault = exports.Permissions = exports.EnumNotFoundError = exports.PermissionError = exports.Claims = exports.AttributeError = exports.ErrorCollector = exports.ClaimError = void 0;
exports.requiredStringAttribute = requiredStringAttribute;
exports.requiredStringArrayAttribute = requiredStringArrayAttribute;
exports.requiredNumberAttribute = requiredNumberAttribute;
exports.requiredBooleanAttribute = requiredBooleanAttribute;
exports.fromWire = fromWire;
exports.boolean2String = boolean2String;
exports.boolean2number = boolean2number;
exports.sanitizeStringArray = sanitizeStringArray;
exports.toString = toString;
exports.toNumber = toNumber;
exports.toBoolean = toBoolean;
exports.isSome = isSome;
exports.testClaims = testClaims;
const boum_claims_1 = require("./boum-claims");
const boum_right_1 = require("./boum-right");
const cognito_claims_1 = require("./cognito-claims");
const customer_claims_1 = require("./customer-claims");
const employee_claims_1 = require("./employee-claims");
const employee_right_1 = require("./employee-right");
const internal_claims_1 = require("./internal-claims");
const open_id_claims_1 = require("./open-id-claims");
class ClaimError extends Error {
    constructor(claim, message) {
        super(message);
        this.claim = claim;
    }
}
exports.ClaimError = ClaimError;
class ErrorCollector {
    constructor(module) {
        this.errors = [];
        this.module = module;
    }
    add(error) {
        if (typeof error === 'string') {
            this.errors.push(new Error(error));
            return;
        }
        this.errors.push(error);
    }
    lastError() {
        return this.errors[this.errors.length - 1];
    }
    isError() {
        return this.errors.length > 0;
    }
}
exports.ErrorCollector = ErrorCollector;
class AttributeError extends ClaimError {
    constructor(module, typ, attribute, value) {
        super(module, `Missing required ${typ} attribute ${attribute} => ${value}`);
        this.attribute = attribute;
        this.value = value;
        this.typ = typ;
    }
}
exports.AttributeError = AttributeError;
function requiredStringAttribute(claims, attribute, defaultValue, ec) {
    const value = claims[attribute];
    if (typeof value === 'undefined' ||
        value === null ||
        typeof value !== 'string') {
        ec.add(new AttributeError(ec.module, 'string', attribute, value));
        return WithDefault.from(undefined, defaultValue);
    }
    return WithDefault.from(value, defaultValue);
}
function requiredStringArrayAttribute(claims, attribute, defaultValue, ec) {
    const value = claims[attribute];
    if (typeof value === 'undefined' || value === null) {
        ec.add(new AttributeError(ec.module, 'string[]', attribute, value));
        return WithDefault.from(undefined, defaultValue);
    }
    if (Array.isArray(value)) {
        return WithDefault.from(value.map(i => '' + i), defaultValue);
    }
    if (typeof value !== 'string') {
        return WithDefault.from(['' + value], defaultValue);
    }
    return WithDefault.from(Array.from(new Set(value
        .split(',')
        .map(i => i.trim())
        .filter(i => i.length > 0))), defaultValue);
}
function requiredNumberAttribute(claims, attribute, defaultValue, ec) {
    const value = claims[attribute];
    if (typeof value === 'undefined' ||
        value === null ||
        typeof value !== 'number') {
        ec.add(new AttributeError(ec.module, 'number', attribute, value));
        return WithDefault.from(undefined, defaultValue);
    }
    return WithDefault.from(value, defaultValue);
}
function requiredBooleanAttribute(claims, attribute, defaultValue, ec) {
    const value = claims[attribute];
    if (!value) {
        ec.add(new AttributeError(ec.module, 'boolean', attribute, value));
        return WithDefault.from(undefined, defaultValue);
    }
    if (typeof value === 'string') {
        return WithDefault.from(!(value.toLowerCase() === 'false' ||
            value === '0' ||
            value.toLowerCase() === 'no'), defaultValue);
    }
    return WithDefault.from(!!value, defaultValue);
}
function prefixError(prefix, errors) {
    return errors.map(e => new Error(`${prefix}: ${e.message}`));
}
class Claims {
    // params is only used for versioning
    // if we add new claims to param the compiler in the using
    // application will force the developer to update the code
    static fromWireClaims(claims, params) {
        const openID = (0, open_id_claims_1.FromOpenIDWireClaims)(claims, params.defaultOpenID);
        const cognito = (0, cognito_claims_1.FromCognitoWireClaims)(claims, params.defaultCognito);
        const boum = (0, boum_claims_1.FromBoumWireClaims)(claims, params.defaultBOUM);
        const employee = (0, employee_claims_1.FromEmployeeWireClaims)(claims, params.defaultEmployee);
        const customer = (0, customer_claims_1.FromCustomerWireClaims)(claims, params.defaultCustomer);
        const internal = (0, internal_claims_1.FromInternalWireClaims)(claims, params.defaultInternal);
        return new Claims(openID, cognito, boum, employee, customer, internal);
    }
    static fromSimpleClaims(iparams, claims = {}, now = Date.now()) {
        return this.fromWireClaims(claims, {
            defaultOpenID: { ...(0, open_id_claims_1.TestOpenIDClaims)(now), ...iparams.defaultOpenID },
            defaultCognito: { ...(0, cognito_claims_1.TestCognitoClaims)(), ...iparams.defaultCognito },
            defaultBOUM: { ...(0, boum_claims_1.TestBoumClaims)(), ...iparams.defaultBOUM },
            defaultEmployee: { ...(0, employee_claims_1.TestEmployeeClaims)(), ...iparams.defaultEmployee },
            defaultCustomer: { ...(0, customer_claims_1.TestCustomerClaims)(), ...iparams.defaultCustomer },
        });
    }
    constructor(openID, cognito, boum, employee, customer, internal) {
        this.openID = openID;
        this.cognito = cognito;
        this.boum = boum;
        this.employee = employee;
        this.customer = customer;
        this.internal = internal;
    }
    toParams() {
        return {
            defaultOpenID: this.openID.toParams(),
            defaultCognito: this.cognito.toParams(),
            defaultBOUM: this.boum.toParams(),
            defaultEmployee: this.employee.toParams(),
            defaultCustomer: this.customer.toParams(),
            defaultInternal: this.internal.toParams(),
        };
    }
    isError() {
        return (this.boum.isError() ||
            this.cognito.isError() ||
            this.openID.isError() ||
            this.employee.isError() ||
            this.customer.isError() ||
            this.internal.isError());
    }
    errors() {
        return [
            ...prefixError('boum', this.boum.errors()),
            ...prefixError('cognito', this.cognito.errors()),
            ...prefixError('openId', this.openID.errors()),
            ...prefixError('employee', this.employee.errors()),
            ...prefixError('customer', this.customer.errors()),
            ...prefixError('internal', this.internal.errors()),
        ];
    }
    lastError() {
        throw new Error('Method not implemented.');
    }
    hasRights(rights) {
        for (const right of rights) {
            if (right instanceof employee_right_1.EmployeeRight) {
                if (this.employee.employeeRights().has(right)) {
                    return true;
                }
            }
            if (right instanceof boum_right_1.BoumRight) {
                if (this.boum.userRights().has(right)) {
                    return true;
                }
            }
        }
        return false;
    }
    toJSON() {
        return {
            ...this.openID.toJSON(),
            ...this.cognito.toJSON(),
            ...this.boum.toJSON(),
            ...this.employee.toJSON(),
            ...this.customer.toJSON(),
            ...this.internal.toJSON(),
        };
    }
}
exports.Claims = Claims;
class PermissionError extends ClaimError {
    constructor(claim, permissionType, permission) {
        super(claim, `Missing required ${permissionType} permission ${permission}`);
        this.permission = permission;
        this.permissionType = permissionType;
    }
}
exports.PermissionError = PermissionError;
class EnumNotFoundError extends ClaimError {
    constructor(claim, enumType, rightValue, rightValues) {
        super(claim, `Missing required ${enumType} of ${rightValue} in ${rightValues}`);
        this.enumType = enumType;
        this.rightValue = rightValue;
        this.rightValues = rightValues;
    }
}
exports.EnumNotFoundError = EnumNotFoundError;
function fromWire(w) {
    return isSome(w) ? w.val : undefined;
}
function coerce2right(values) {
    const ret = values
        .map(i => {
        if (typeof i.toEnums === 'function') {
            return i.toEnums();
        }
        return [i];
    })
        .flat();
    return Array.from(new Set(ret));
}
class Permissions {
    constructor(values, ende, ec) {
        _Permissions_values.set(this, void 0);
        _Permissions_ende.set(this, void 0);
        __classPrivateFieldSet(this, _Permissions_values, values, "f");
        __classPrivateFieldSet(this, _Permissions_ende, ende, "f");
        this.errors = ec;
    }
    static FromString(ende, ...ivalues) {
        const ec = ivalues.find(i => i instanceof ErrorCollector) ||
            new ErrorCollector(ende.name());
        const enums = ivalues.filter(i => !(i && i instanceof ErrorCollector)).flat()
            .map(i => {
            if (typeof i !== 'string') {
                const y = ende.fromEnum(i !== null && i !== void 0 ? i : undefined);
                if (y === undefined) {
                    ec.add(new PermissionError(ec.module, ende.name(), '' + i));
                }
                return y;
            }
            return i.split(',').map(i => i.trim());
        })
            .flat()
            .filter(i => i).reduce((acc, ix) => {
            const enu = ende.toEnum(ix);
            if (enu) {
                acc.add(enu);
            }
            else {
                ec.add(new PermissionError(ec.module, ende.name(), ix));
            }
            return acc;
        }, new Set());
        return new Permissions(enums, ende, ec);
    }
    static ToString(ende, rights) {
        if (typeof rights === 'string') {
            rights = rights.split(',').map(i => i.trim());
        }
        if (Array.isArray(rights)) {
            return rights
                .map(i => {
                if (typeof i === 'string') {
                    i = ende.toEnum(i);
                }
                return ende.fromEnum(i);
            })
                .filter(i => i)
                .join(',');
        }
        if (rights) {
            return rights.toString();
        }
        return undefined;
    }
    hasNoRights() {
        return __classPrivateFieldGet(this, _Permissions_values, "f").size === 0;
    }
    hasRights() {
        return !this.hasNoRights();
    }
    has(value, ec = new ErrorCollector('undefined')) {
        const ret = __classPrivateFieldGet(this, _Permissions_values, "f").has(value);
        if (!ret) {
            ec.add(new EnumNotFoundError(ec.module, __classPrivateFieldGet(this, _Permissions_ende, "f").name(), value, this.toString()));
        }
        return ret;
    }
    some(...values) {
        return coerce2right(values).some(i => __classPrivateFieldGet(this, _Permissions_values, "f").has(i));
    }
    every(...values) {
        return coerce2right(values).every(i => __classPrivateFieldGet(this, _Permissions_values, "f").has(i));
    }
    toEnums() {
        const s = this.toStrings();
        if (s.length === 0) {
            return [];
        }
        return s.map(i => __classPrivateFieldGet(this, _Permissions_ende, "f").toEnum(i));
    }
    toStrings() {
        return Array.from(__classPrivateFieldGet(this, _Permissions_values, "f"))
            .map(i => __classPrivateFieldGet(this, _Permissions_ende, "f").fromEnum(i))
            .filter(i => !!i)
            .sort();
    }
    toBits() {
        const { maxBit, bits } = Array.from(__classPrivateFieldGet(this, _Permissions_values, "f"))
            .map(i => i.bit())
            .reduce((acc, i) => {
            acc.bits.push(i);
            acc.maxBit = Math.max(acc.maxBit, i);
            return acc;
        }, {
            maxBit: 0,
            bits: [],
        });
        const out = new Uint8Array((maxBit + 8) / 8);
        for (const bit of bits) {
            out[~~(bit / 8)] |= 1 << bit % 8;
        }
        return out;
    }
    toString() {
        return this.toStrings().join(',');
    }
    toJSON() {
        return this.toStrings();
    }
}
exports.Permissions = Permissions;
_Permissions_values = new WeakMap(), _Permissions_ende = new WeakMap();
function boolean2String(x) {
    return x.val ? '1' : '0';
}
function boolean2number(x) {
    return x.val ? 1 : 0;
}
function sanitizeStringArray(x) {
    return Array.from(new Set(x.map(i => i.trim()))).sort();
}
function toString(w) {
    const x = Array.isArray(w.val) ? w.val : [w.val];
    return sanitizeStringArray(x).join(',');
}
function toNumber(w) {
    return w.val;
}
function toBoolean(w) {
    return w.val;
}
function isSome(w) {
    if (w.byDefault) {
        return false;
    }
    const x = w.val;
    if (Array.isArray(x)) {
        return x.length !== 0;
    }
    if (typeof x === 'string') {
        return x.trim() !== '';
    }
    if (typeof x === 'number') {
        return true;
    }
    if (typeof x === 'boolean') {
        return x;
    }
    if (typeof x.enums === 'function') {
        return x.enums().length !== 0;
    }
    return true;
}
class WithDefault {
    static from(value, defaultValue) {
        if (value === undefined || value === null) {
            return new WithDefault(defaultValue, true);
        }
        const per = value;
        if (typeof per.toEnums === 'function') {
            const enums = per.toEnums();
            if (enums.length === 0) {
                return new WithDefault(defaultValue, true);
            }
        }
        return new WithDefault(value, false);
    }
    constructor(value, defaultValue) {
        this.val = value;
        this.byDefault = defaultValue;
    }
}
exports.WithDefault = WithDefault;
class ClaimsBuilder {
    static fromWire(w) {
        return new ClaimsBuilder(Claims.fromWireClaims(w, {
            defaultOpenID: {},
            defaultCognito: {},
            defaultBOUM: {},
            defaultEmployee: {},
            defaultCustomer: {},
            defaultInternal: {},
        }));
    }
    static fromSimple(iparams = {}, now = Date.now()) {
        return new ClaimsBuilder(Claims.fromSimpleClaims({
            defaultOpenID: {},
            defaultCognito: {},
            defaultBOUM: {},
            defaultEmployee: {},
            defaultCustomer: {},
            defaultInternal: {},
            ...iparams,
        }, {}, now));
    }
    static fromClaims(claims) {
        return ClaimsBuilder.fromWire(claims.toJSON());
    }
    constructor(claims) {
        _ClaimsBuilder_openID.set(this, void 0);
        _ClaimsBuilder_cognito.set(this, void 0);
        _ClaimsBuilder_boum.set(this, void 0);
        _ClaimsBuilder_employee.set(this, void 0);
        _ClaimsBuilder_customer.set(this, void 0);
        _ClaimsBuilder_internal.set(this, void 0);
        __classPrivateFieldSet(this, _ClaimsBuilder_openID, new open_id_claims_1.OpenIDBuilder(claims.openID.toParams()), "f");
        __classPrivateFieldSet(this, _ClaimsBuilder_cognito, new cognito_claims_1.CognitoBuilder(claims.cognito.toParams()), "f");
        __classPrivateFieldSet(this, _ClaimsBuilder_boum, new boum_claims_1.BoumBuilder(claims.boum.toParams()), "f");
        __classPrivateFieldSet(this, _ClaimsBuilder_employee, new employee_claims_1.EmployeeBuilder(claims.employee.toParams()), "f");
        __classPrivateFieldSet(this, _ClaimsBuilder_customer, new customer_claims_1.CustomerBuilder(claims.customer.toParams()), "f");
        __classPrivateFieldSet(this, _ClaimsBuilder_internal, new internal_claims_1.InternalBuilder(claims.internal.toParams()), "f");
    }
    build(bv) {
        const openID = __classPrivateFieldGet(this, _ClaimsBuilder_openID, "f").build();
        const cognito = __classPrivateFieldGet(this, _ClaimsBuilder_cognito, "f").build();
        const boum = __classPrivateFieldGet(this, _ClaimsBuilder_boum, "f").build(bv ? bv.boum : undefined);
        const employee = __classPrivateFieldGet(this, _ClaimsBuilder_employee, "f").build();
        const customer = __classPrivateFieldGet(this, _ClaimsBuilder_customer, "f").build();
        const internal = __classPrivateFieldGet(this, _ClaimsBuilder_internal, "f").build();
        return Claims.fromWireClaims({}, {
            defaultBOUM: boum.toParams(),
            defaultCognito: cognito.toParams(),
            defaultEmployee: employee.toParams(),
            defaultCustomer: customer.toParams(),
            defaultOpenID: openID.toParams(),
            defaultInternal: internal.toParams(),
        });
    }
    openID(fn) {
        fn(__classPrivateFieldGet(this, _ClaimsBuilder_openID, "f"));
        return this;
    }
    cognito(fn) {
        fn(__classPrivateFieldGet(this, _ClaimsBuilder_cognito, "f"));
        return this;
    }
    boum(fn) {
        fn(__classPrivateFieldGet(this, _ClaimsBuilder_boum, "f"));
        return this;
    }
    employee(fn) {
        fn(__classPrivateFieldGet(this, _ClaimsBuilder_employee, "f"));
        return this;
    }
    customer(fn) {
        fn(__classPrivateFieldGet(this, _ClaimsBuilder_customer, "f"));
        return this;
    }
    internal(fn) {
        fn(__classPrivateFieldGet(this, _ClaimsBuilder_internal, "f"));
        return this;
    }
}
exports.ClaimsBuilder = ClaimsBuilder;
_ClaimsBuilder_openID = new WeakMap(), _ClaimsBuilder_cognito = new WeakMap(), _ClaimsBuilder_boum = new WeakMap(), _ClaimsBuilder_employee = new WeakMap(), _ClaimsBuilder_customer = new WeakMap(), _ClaimsBuilder_internal = new WeakMap();
function testClaims(now = 815, cv = { boum: 'V1' }) {
    return Claims.fromSimpleClaims({
        defaultOpenID: (0, open_id_claims_1.TestOpenIDClaims)(now),
        defaultCognito: (0, cognito_claims_1.TestCognitoClaims)(),
        defaultBOUM: (0, boum_claims_1.TestBoumClaims)(cv.boum),
        defaultEmployee: (0, employee_claims_1.TestEmployeeClaims)(),
        defaultCustomer: (0, customer_claims_1.TestCustomerClaims)(),
    }, {}, now);
}
//# sourceMappingURL=claims.js.map